import type { OpCoInfo } from "@utils/get-opco-with-locale";
import { createContext } from "react";

export const BrandContext = createContext<OpCoInfo | undefined>(undefined);
